/* eslint-disable */
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react'
import { Popover } from '@headlessui/react'
import { usePopper } from 'react-popper'
import { cadFormatter, formatMoney } from 'utils/formatters'
import { AVAILABILITY_BG_COLOR } from 'utils'
import { ReactComponent as UnitBathroomIcon } from 'assets/icons/unitBathroom.svg'
import { ReactComponent as UnitBedroomIcon } from 'assets/icons/unitBedroom.svg'
import { ReactComponent as UnitParkingIcon } from 'assets/icons/unitParking.svg'
import InventoryContext from 'pages/desktopMode/inventory/Allocation/AllocateInventory/Context/InventoryContext'
import { Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { ADMIN_OFFER } from 'routes'
import { getUnitEventEmitter } from 'hooks/useRealtimeUnitUpdate'
import AddParkingModal from 'pages/desktopMode/buildings/components/AddParkingModal'

const getPopperAttributes = (popperAttributes, isOnRightSide) => {
  return {
    ...popperAttributes,
    'data-popper-placement': `${popperAttributes?.['data-popper-placement']}-${
      isOnRightSide ? 'end' : 'start'
    }`
  }
}

const getPopperStyles = (popperStyles, isOnRightSide) => {
  if (isOnRightSide) {
    popperStyles.right = '0'
  } else {
    popperStyles.left = '0'
  }
  return { ...popperStyles }
}

const HorizontalCardUnit = ({
  imgSrc = '',
  parkingName = '',
  price = 0,
  priceSquareFoot = null,
  bedroomsQuantity = 1,
  bathroomsQuantity = 1,
  parkingQuantity = 1,
  tag = '',
  leftButtonLabel = '',
  onLeftButtonClick = () => {},
  rightButtonLabel = '',
  onRightButtonClick = () => {},
  showActionButtonOnHover = true,
  isPublicPage = false
}) => {
  return (
    <div>
      <div className='flex p-4'>
        <img
          src={imgSrc}
          alt='Plan'
          className='object-cover w-[181.3px] h-[144px]'
        />
        <div className='ml-4 flex flex-col text-softBlack'>
          <div
            className={
              'font-medium text-xs px-1 py-[4.5px] w-[171px] h-[27px] uppercase'
            }
            style={{
              backgroundColor: AVAILABILITY_BG_COLOR[tag.toLowerCase()]
            }}
          >
            {tag}
          </div>
          <div className='font-bold text-2xl mt-2'>{parkingName}</div>
          <div className='font-medium text-sm mt-[9px]'>
            {formatMoney(price)}
            {priceSquareFoot
              ? ` / ${cadFormatter.format(priceSquareFoot)} SQ. FT`
              : ''}
          </div>
          <div className='flex space-x-3 mt-[9px] text-base font-normal'>
            <div className='flex items-center mx-1.5'>
              <UnitBedroomIcon />
              {bedroomsQuantity} Br
            </div>
            <div className='flex items-center mx-1.5'>
              <UnitBathroomIcon />
              {bathroomsQuantity} Ba
            </div>
            <div className='flex items-center mx-1.5'>
              <UnitParkingIcon />
              {parkingQuantity} Pa
            </div>
          </div>
        </div>
      </div>
      {!isPublicPage && (
        <div className='flex justify-end w-full space-x-4 font-medium mb-4 px-4'>
          {leftButtonLabel.length ? (
            <button
              onClick={onLeftButtonClick}
              className='w-40 h-12 rounded border border-softBlack70'
            >
              {leftButtonLabel}
            </button>
          ) : null}
          {showActionButtonOnHover &&
          !tag?.toLowerCase()?.includes('sold') &&
          rightButtonLabel.length ? (
            <button
              onClick={onRightButtonClick}
              className='w-32 h-12 rounded bg-volt'
            >
              {rightButtonLabel}
            </button>
          ) : null}
        </div>
      )}
    </div>
  )
}

const ParkingItem = ({
  unit: unitData,
  floor,
  bedroomCount,
  bathroomCount,
  price,
  isDisabled,
  isOnRightSide,
  type,
  onSelect = (unit) => {},
  showActionButtonOnHover = true,
  isAllocateInventory = false,
  isPublicPage = false,
  refetchUnits
}) => {
  const [unit, setUnit] = useState(unitData)
  const [referenceElement, setReferenceElement] = useState()
  const [popperElement, setPopperElement] = useState()
  const { styles, attributes } = usePopper(referenceElement, popperElement)
  const isStatic = { static: isAllocateInventory ? true : false }
  const [isSelected, setIsSelected] = useState(false)
  const selectedUnits = useContext(InventoryContext)
  const [showParkingEditModal, setShowParkingEditModal] = useState(false)
  const history = useHistory()

  useEffect(() => handleSelect(unit, selectedUnits), [selectedUnits])

  useEffect(() => {
    setUnit({ ...unitData })
  }, [unitData])

  const handleSelect = (unit, selectedUnitsTemp) => {
    if (isAllocateInventory) {
      let unitFound = false
      if (selectedUnitsTemp.length > 0) {
        for (let i = 0; i < selectedUnitsTemp.length; i++) {
          const unit2 = selectedUnitsTemp[i]
          if (unit.id === unit2.id) {
            setIsSelected(true)
            unitFound = true
            break
          }
        }
      }
      if (!unitFound) setIsSelected(false)
    }
  }

  const onEditUnitClicked = useCallback((unit) => {
    setShowParkingEditModal(true)
  }, [])

  const onUnitRealtimeUpdate = useCallback(
    (newData) => {
      if (unit._id === newData.id || unit._id === newData._id) {
        setUnit({ ...newData })
      }
    },
    [unit]
  )

  useEffect(() => {
    getUnitEventEmitter()?.addListener('unit-update', onUnitRealtimeUpdate)
    return () => {
      getUnitEventEmitter()?.removeListener('unit-update', onUnitRealtimeUpdate)
    }
  }, [])

  const buttonContent = (unit) => (
    <span
      className={`text-sm ${
        isDisabled ? 'text-softBlack30' : 'text-softBlack'
      }`}
    >
      <span className='font-medium'>{`#${
        unit?.unitNumber ?? ''
      } - ${bedroomCount}Br / ${bathroomCount}Ba`}</span>
      <br />
      <span className='font-normal'>{formatMoney(price)}</span>
    </span>
  )

  return (
    <>
      {showParkingEditModal && (
        <AddParkingModal
          show={showParkingEditModal}
          setShow={setShowParkingEditModal}
          editDetails={{ ...unit, type: 'Units' }}
          setEditDetails={() => {}}
          refetch={() => {
            refetchUnits?.()
          }}
          building={unit?.building?._id ?? null}
        />
      )}
      <Popover
        className={'group h-[59px] flex-1'}
        style={{
          backgroundColor:
            isDisabled || (isAllocateInventory && unit.status !== 'Open')
              ? '#F2F2F1'
              : AVAILABILITY_BG_COLOR[unit?.status?.toLowerCase()]
        }}
      >
        <Popover.Button
          // @ts-ignore
          ref={setReferenceElement}
          className={`flex w-full h-full items-center justify-center text-center ${
            isSelected && 'border-2 rounded border-solid border-softBlack'
          }`}
          disabled={
            !isAllocateInventory
              ? isDisabled
              : unit.status === 'Open'
              ? false
              : true
          }
          onClick={() => {
            return type === 'offerFlow' && onSelect(unit)
          }}
        >
          {isAllocateInventory && unit.status !== 'Open' ? (
            <Tooltip
              title={
                <h1
                  style={{
                    color: 'rgba(255, 255, 255, 1)',
                    fontSize: 14,
                    paddingTop: 4
                  }}
                >
                  This unit is already reserved by another buyer
                </h1>
              }
              arrow
              placement='bottom'
            >
              {buttonContent(unit)}
            </Tooltip>
          ) : (
            buttonContent(unit)
          )}
        </Popover.Button>
        {!isAllocateInventory && (
          <Popover.Panel
            {...isStatic}
            className='absolute z-10 mt-1 top-full max-w-[490.3px] rounded bg-[#FCFCFA] shadow'
            // @ts-ignore
            ref={setPopperElement}
            style={getPopperStyles(styles.popper, isOnRightSide)}
            {...getPopperAttributes(attributes.popper, isOnRightSide)}
          >
            <HorizontalCardUnit
              imgSrc={unit?.floorPlan?.image}
              parkingName={`Parking #${unit?.unitNumber}`}
              price={unit?.price}
              bedroomsQuantity={unit?.numberOfBedrooms}
              bathroomsQuantity={unit?.numberOfBathrooms}
              parkingQuantity={unit?.floorPlan?.parkingQty}
              tag={unit?.status}
              leftButtonLabel={'Edit'}
              onLeftButtonClick={() => {
                onEditUnitClicked(unit)
              }}
              rightButtonLabel='Purchase'
              onRightButtonClick={() => {
                console.log('On right button Clicked')
                history.push(ADMIN_OFFER)
              }}
              showActionButtonOnHover={showActionButtonOnHover}
              isPublicPage={isPublicPage}
            />
          </Popover.Panel>
        )}
      </Popover>
    </>
  )
}

export default ParkingItem
